import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { canChangeSiteAvailability } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { Messages } from '../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';
import { SiteAvailabilityState } from '../../sites/SitePropertyTypes';
import { activateSite } from '../actions/SiteMenuActions';

export const ActivateSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.ActivateSite,
  translateName: Messages.activate_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return canChangeSiteAvailability(targetItems, SiteAvailabilityState.ACTIVE);
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => activateSite(targetItems)
};
